
import { AcceptanceTermProvider } from "../../hooks/useAcceptanceTerm";
import Acceptance from '../../components/Acceptance';


export default function AcceptanceTerm() {


    return (
        <AcceptanceTermProvider>
            <Acceptance />
        </AcceptanceTermProvider>
    )
}